export default __webpack_public_path__ + "static/media/bellGray.55559e2a.svg";